/**
 * DirectoryNewsletterStrip — global "Subscribe to HustleDirectory" strip
 * dropped near the footer of DirectoryPage.jsx. Broad list, biz_slug=null.
 */
import { useState } from "react";
import { Mail } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL || (typeof window !== "undefined" ? window.location.origin : "");

export default function DirectoryNewsletterStrip({ stateCode }) {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true); setError("");
    try {
      const r = await fetch(`${API}/api/directory/subscribe`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, state_code: stateCode || null }),
      });
      const j = await r.json();
      if (!r.ok) { setError(j.detail || "Could not subscribe."); setBusy(false); return; }
      setDone(true);
    } catch (err) { setError(err.message); }
    setBusy(false);
  };

  return (
    <div className="max-w-6xl mx-auto px-4 my-8">
      <div
        data-testid="directory-newsletter"
        className="bg-gradient-to-br from-stone-900 to-stone-700 rounded-2xl px-6 py-6 sm:px-8 sm:py-8 text-white flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-8"
      >
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-1 text-amber-300 text-[12px] font-semibold uppercase tracking-wider">
            <Mail className="w-3.5 h-3.5" /> HustleDirectory
          </div>
          <h3 className="font-serif text-xl sm:text-2xl">New listings weekly. Straight to your inbox.</h3>
          <p className="text-white/70 text-[13px] mt-1">
            Get the best new cafés, tradies and hotels near you — no spam, unsubscribe with one click.
          </p>
        </div>
        {done ? (
          <div className="w-full md:w-auto md:min-w-[280px] py-3 px-4 rounded-lg bg-emerald-500 text-white text-center font-semibold" data-testid="directory-newsletter-thanks">
            Subscribed — welcome aboard!
          </div>
        ) : (
          <form onSubmit={submit} className="w-full md:w-auto flex flex-col sm:flex-row gap-2 md:min-w-[380px]">
            <input
              data-testid="directory-newsletter-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="your@email.com"
              className="flex-1 px-4 py-3 rounded-lg text-stone-900 text-[14px] focus:outline-none focus:ring-2 focus:ring-amber-400"
            />
            <button
              data-testid="directory-newsletter-submit"
              disabled={busy || !email}
              className="px-5 py-3 rounded-lg bg-amber-400 text-stone-900 font-semibold hover:bg-amber-300 disabled:opacity-60 whitespace-nowrap"
            >
              {busy ? "Sending…" : "Subscribe"}
            </button>
          </form>
        )}
        {error && !done && (
          <div className="text-[12px] text-rose-300 md:absolute md:right-8" data-testid="directory-newsletter-error">{error}</div>
        )}
      </div>
    </div>
  );
}
